// extracted by mini-css-extract-plugin
export default {"wrapper":"x8","container":"y8","image":"z8","info":"A8","title":"B8","note":"C8","product":"E8","product_img":"F8","description":"G8","name":"H8","whybtn":"I8","buttons":"J8"};
    if(module.hot) {
      // 1713969939313
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  